import { FC } from 'react'
import { Question } from 'types/faq'
import { FaqSectionProps as Props } from './types'
import styles from './FaqSection.module.scss'
import classNames from 'classnames'
import parse from 'html-react-parser'
import Image from 'next/image'

const FaqSection: FC<Props> = ({ section, questions, selectedQuestionId, setSelectedQuestionId, hideTitle }) => {
  const sectionId = section.id.toString()

  return (
    <li id={sectionId}>
      {!hideTitle && <h3>{section.name}</h3>}

      <div className={styles.questions}>
        {questions
          .filter((question: Question) => question.faq_section.includes(section.id))
          .map((question: Question) => (
            <div key={question.id} className={classNames({ [styles.selected]: selectedQuestionId === question.id })}>
              <div className={styles.question}>
                <button onClick={() => setSelectedQuestionId(selectedQuestionId === question.id ? null : question.id)}>
                  <div className={styles['question-top']}>
                    <span>{parse(question.title.rendered)}</span>
                    <div className={styles['icon-container']}>
                      <Image src="/images/common/collapse.png" width={24} height={24} alt="Collapse job" />
                    </div>
                  </div>

                  <p role="presentation" onClick={(e) => e.stopPropagation()}>
                    {parse(question.acf.answer)}
                  </p>
                </button>
              </div>
            </div>
          ))}
      </div>
    </li>
  )
}

FaqSection.defaultProps = {
  hideTitle: false
}

export default FaqSection
